module.exports = __webpack_public_path__ + "static/HeroPicture.e26d314e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/HeroPicture.svg
// module id = 701
// module chunks = 216210090109534